import React, { useEffect, useRef, useState } from 'react';
import { strings } from '../constants/strings';
import { colors } from '../constants/colors';
import { Check } from 'lucide-react';

const WhatAreWe = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.2 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <section className="section-padding" ref={sectionRef} style={{ background: colors.backgroundAlt }}>
      <div className="container">
        <div className="what-are-we-grid">
          <div className={`what-content ${isVisible ? 'slide-in-left' : ''}`}>
            <h2 className="section-title">{strings.whatAreWe.title}</h2>
            <p className="large-text">{strings.whatAreWe.content}</p>
            <p className="body-text" style={{ marginTop: '24px' }}>{strings.whatAreWe.subtitle}</p>
            
            <div className="decorative-line"></div>
          </div>
          
          <div className={`key-points ${isVisible ? 'slide-in-right' : ''}`}>
            {strings.whatAreWe.keyPoints.map((point, index) => (
              <div 
                key={index} 
                className="key-point-item"
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                <div className="check-icon">
                  <Check size={20} strokeWidth={3} />
                </div>
                <span>{point}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhatAreWe;
